import React,{Component} from "react";
import HomeHero from "../components/HomeHero";

class Home extends Component{
    render(){
        return (
                <React.Fragment>
                  <HomeHero/>
                </React.Fragment>);    
    }
}

export default Home;